import React from "react";
import {
  ChecklistsDashboard,
  ChecklistWizard,
  ChecklistReview,
  ChecklistHistory,
  ChecklistConfig,
  ChecklistIssues,
} from "@/components/ops/checklists";

export interface OsChecklistsWindowContentProps {
  /** Window params from `parseUrlToWindowConfig` / `openWindow` */
  params: Record<string, string>;
}

/**
 * Routes ops-checklists window state to the correct checklist UI (dashboard,
 * run wizard, review, history, config, issues) based on OS window params.
 *
 * @see {@link ../../../../docs/os-aware-navigation.md}
 */
export function OsChecklistsWindowContent({
  params,
}: OsChecklistsWindowContentProps) {
  const { runId, checklistView } = params;

  if (checklistView === "review" && runId) {
    return <ChecklistReview windowRunId={runId} />;
  }
  if (runId) {
    return <ChecklistWizard windowRunId={runId} />;
  }
  if (checklistView === "history") {
    return <ChecklistHistory />;
  }
  if (checklistView === "config") {
    return <ChecklistConfig />;
  }
  if (checklistView === "issues") {
    return <ChecklistIssues />;
  }

  return <ChecklistsDashboard />;
}
